import React from 'react';
import { Div, GridBag, Input, Link } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

import { BundleVariantProps } from './types';
import VariantErrorNotifications from './VariantErrorNotifications';

export const BundleVariant = ({ acquisitionPrices, errors, variant, onTfapPriceOverridenAmountChange, country }: BundleVariantProps) => {
  const { t } = useTranslation('bundlesview');

  const tfapPrice = acquisitionPrices.find(aPrice => aPrice.variant_id === variant.id);
  const variantErrors = errors[variant.id];

  const formatDefaultTfapValue = (price: number | undefined, overridePrice: number | undefined) => {
    let classNameForPrice = '';
    if (price === undefined) {
      return <span className={'sales-channel-drawer__alert-text'}>{t('errors.missingPrice')}</span>;
    }
    if (overridePrice) {
      classNameForPrice = 'sales-channel-drawer__format-variant-price-strike';
    }
    return <span className={classNameForPrice}>{price}</span>;
  };

  return (
    <Div key={variant.id} padding={{ bottom: 'xs' }} className={'sales-channel-drawer__centering-horizontal'}>
      <GridBag className={'sales-channel-drawer__centering-horizontal'}>
        <GridBag.Item md={6} className={'sales-channel-drawer__format-variant-text'} occupyVerticalSpace>
          <Link to={`/product/${variant.product_id}/main/${country.code.toLowerCase()}`}>{variant.name}</Link>
        </GridBag.Item>
        <GridBag.Item md={3}>{formatDefaultTfapValue(tfapPrice?.default_amount, tfapPrice?.overridden_amount)}</GridBag.Item>
        <GridBag.Item md={3}>
          <Input
            // @ts-expect-error Type 'number' is not assignable to type 'text' | 'search' | 'tel' | 'url' | 'email' | 'password' | undefined
            type={'number'}
            showCustomLabel={true}
            label={''}
            onChange={(_event, value) => onTfapPriceOverridenAmountChange(variant, value)}
            value={tfapPrice?.overridden_amount?.toString()}
            data-testid={`bundle-variant-${variant.id}-tfap-price-overriden-amount`}
          />
        </GridBag.Item>
      </GridBag>

      {variantErrors && <VariantErrorNotifications variantErrors={variantErrors} t={t} countryName={country.name} />}
    </Div>
  );
};
